import React from 'react'
import Link from 'gatsby-link'

import Logo from '../images/cohoots-foundation-logo.png'

const Header = ({ siteTitle }) => (
  <header className="">
    <div className="grid-x grid-padding-x content">
      <div className="cell small-6 medium-5 ">
        <h1 className="logo">
          <Link
            to="/"
            style={{
              textDecoration: 'none',
            }}
            className="header-link"
          >
            Youth<br />
            <span>Change</span>Maker<br />Summit
          </Link>
        </h1>
      </div>

      <div className="cell small-6 medium-4 large-4 next-event">
        <h2>
          Scottsdale, AZ<br />
          <small>
          Feb 7<sup>th</sup>&mdash;9<sup>th</sup>, 2020
          </small>
        </h2>
        <Link className="button" to="/register/">
          Register Now
        </Link>
      </div>

      <div className="cell medium-3 hide-for-small-only cfdn-logo">
        <p>Presented by:</p>
        <a
          href="https://cohootsfdn.org"
          title="Presented by the Co+Hoots Foundation"
          className="header-logo "
        >
          <img src={Logo} alt={siteTitle} />
        </a>
      </div>
    </div>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js